import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/tvSeries';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">{t('siteName')}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t('footerDesc')}
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">{t('categoryTitle')}</h4>
            <ul className="flex flex-wrap gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className="flex flex-wrap gap-2 mt-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">{t('about')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  {t('contactUs')}
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                  {t('privacyPolicy')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                  {t('termsOfService')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">{t('contactUs')}</h4>
            <div className="space-y-2 text-sm text-foreground-300">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@alu-expo-1.cn</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：7×24小时</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t('copyright')}</p>
          <p className="text-xs text-foreground-500">{t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
}